import { Component, Input, OnInit } from '@angular/core';
import { eSignature } from '../../../../app/shared/models/eSignature';
import { PanelList } from '../../../shared/models/panel-list';
import { CommonService } from '../../../shared/services/common.service';
import { TrainingOccurrenceDTO } from '../models/training-occurrence';
import { UserTrainingPlanService } from '../services/user-training-plan.service';
import { TrainingQuizAnswerDto } from '../models/trainingQuizAnswerDto';
import { SharedConstants } from '../../../shared/constants/shared-constants';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-training-plan-history-panel-list',
  templateUrl: './training-plan-history-panel-list.component.html',
  styleUrls: ['./training-plan-history-panel-list.component.scss']
})
export class TrainingPlanHistoryPanelListComponent implements OnInit {
  isTrainingRequirementHistoryModelOpen = false;
  isESignatureModalOpen=false;
  eSignatureInfo={} as eSignature;
  @Input() trainingOccurrencesList: TrainingOccurrenceDTO[]=[];
  @Input() selectedPuid : string = ""
  trainingItemId ?: string;
  trainingOccurrenceOrder ? : string;
  timeZoneFormat:string= "(UTC)";
  isQuizAnswerAuditModalOpen : boolean = false;
  
  trainingOccurrencesListInput: PanelList = {
    title: undefined,
    lists: [],
    enableFilter: false,
    enableSort: false,
    enableSelection: false,
  };
  noData: boolean = false;
  trainingQuizAnswerDetails : TrainingQuizAnswerDto[] = []
  trainingRequirementType?:string;
  documentVersionNumber ?: number;
  isSessionDetailsModalOpen: boolean = false;
  sessionIdsLinkedWithCourseTrainingOccurrence : string[]  = [];
  
  constructor(private commonService: CommonService, private userTrainingPlanService: UserTrainingPlanService, 
    private messageService : MessageService){

  }

  ngOnInit(): void {
    this.isTrainingRequirementHistoryModelOpen = true;
    this.trainingOccurrencesListInput.lists = this.trainingOccurrencesList;
    this.noData = this.commonService.IsListEmpty(this.trainingOccurrencesList);
  }  

  getStatusClass(status: string): string {
    switch (status) {
      case 'Pending':
        return 'status-orange';
      case 'Complete':
        return 'status-green';
        case 'Active':
        return 'status-green';
      case 'Cancelled':
      case 'Removed':
      case 'Revoked':
      case 'N/A':
        return 'status-gray';
      case 'Locked':
        return 'status-red';
      default:
        return '';
    }
  }



  openDocument(documentNumber: string, version : string){
    var url = location.origin.concat("/eqms.documentDetails/", documentNumber, ":", version);
    window.open(url, "_blank");
  }

  openCourse(courseNumber : string){
    var url = location.origin.concat("/training/eqms.courses/", courseNumber);
    window.open(url, "_blank");
  }  

  openESignature(eSignatureData:any){
    this.isESignatureModalOpen=true;
    this.eSignatureInfo.esignature=eSignatureData.eSignature.eSignature,
    this.eSignatureInfo.esignatureDateTime=eSignatureData.eSignature.eSignatureDateTime,
    this.eSignatureInfo.esignatureMeaning=eSignatureData.eSignature.eSignatureMeaning
    } 

    openQuizAudit(trainingItemId: string, order : number, type:string, documentVersionNumber : number){
      this.isQuizAnswerAuditModalOpen = false;
      let puid = null
      if(this.selectedPuid == "" || this.selectedPuid == undefined || this.selectedPuid == null){
        puid =  sessionStorage.getItem('puid');
      }
      else{
        puid = this.selectedPuid
      }
      var trainingQuizAnswerId = puid+'_'+ trainingItemId + '_'+ order.toString()
      this.userTrainingPlanService.getTrainingQuizAnswerAudit(trainingQuizAnswerId).subscribe(
        {
          next:(response)=>{
            this.trainingQuizAnswerDetails = response
            this.isQuizAnswerAuditModalOpen = true;
            this.trainingItemId = trainingItemId;
            this.trainingRequirementType = type;
            this.documentVersionNumber = documentVersionNumber
          },
          error:(err)=>{
            this.messageService.add({
              severity: SharedConstants.Severity_Error,
              summary: SharedConstants.Audit_Fail_Error_Message,
              sticky: true
            });
          }
        }
      )
    }

  openSessionDetailsModal = (sessionIds: string[] | null) => {
    if (sessionIds && sessionIds.length > 0) {
      this.sessionIdsLinkedWithCourseTrainingOccurrence = sessionIds;
      this.isSessionDetailsModalOpen = true;
    }
  }
  closeSessionDetailsModal = (isModalShow: boolean) => {
    this.isSessionDetailsModalOpen = isModalShow;
  }

}


